import { CurrencyPipe, DatePipe, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';

@Component({
  standalone: true,
  selector: 'codecraft-program-card',
  template: `
    <div
      *ngIf="program; else loading"
      class="card h-100 d-flex flex-column justify-content-between p-2"
    >
      <div class="card-header d-block p-0">
      <a
        href="https://app.codecraftworks.com/programs/{{ program.id }}"
      >
        <img
          class="card-img w-100"
          ngSrc="{{ program.pictureUrl }}"
          alt="{{ program.name }}"
          priority
          width="512"
          height="512"
          loading="eager"
          [placeholderConfig]="{blur: false}"
          placeholder="data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22160%22%20height%3D%22160%22%20viewBox%3D%220%200%20160%20160%22%3E%3Cstyle%3E%0A%40keyframes%20a0_t%20%7B%200%25%20%7B%20transform%3A%20translate%28133.9px%2C123px%29%20rotate%28-45deg%29%20translate%28-133.9px%2C-123px%29%3B%20%7D%2050%25%20%7B%20transform%3A%20translate%28133.9px%2C123px%29%20rotate%280deg%29%20translate%28-133.9px%2C-123px%29%3B%20%7D%20100%25%20%7B%20transform%3A%20translate%28133.9px%2C123px%29%20rotate%2845deg%29%20translate%28-133.9px%2C-123px%29%3B%20%7D%20%7D%0A%40keyframes%20a1_t%20%7B%200%25%20%7B%20transform%3A%20translate%28167.2px%2C68.7px%29%20rotate%2845deg%29%20translate%28-167.2px%2C-68.7px%29%3B%20%7D%2050%25%20%7B%20transform%3A%20translate%28167.2px%2C68.7px%29%20rotate%280deg%29%20translate%28-167.2px%2C-68.7px%29%3B%20%7D%20100%25%20%7B%20transform%3A%20translate%28167.2px%2C68.7px%29%20rotate%28-45deg%29%20translate%28-167.2px%2C-68.7px%29%3B%20%7D%20%7D%0A%40keyframes%20a2_t%20%7B%200%25%20%7B%20transform%3A%20translate%28109px%2C42.3px%29%20rotate%28-45deg%29%20translate%28-109px%2C-42.3px%29%3B%20%7D%2050%25%20%7B%20transform%3A%20translate%28109px%2C42.3px%29%20rotate%280deg%29%20translate%28-109px%2C-42.3px%29%3B%20%7D%20100%25%20%7B%20transform%3A%20translate%28109px%2C42.3px%29%20rotate%2845deg%29%20translate%28-109px%2C-42.3px%29%3B%20%7D%20%7D%0A%3C/style%3E%3Cg%20transform%3D%22translate%28-50%2C-1%29%22%3E%3Cpath%20d%3D%22M134%2086.6c4.5%200%209%20.8%2013.2%202.5l-1.4%207.4c2.8%201.3%205.4%203%207.6%205l6.3-4.2c3.3%203.3%205.8%207.1%207.6%2011.1l-6.3%204.3c1.1%202.8%201.7%205.8%201.9%208.9l7.4%201.4c0%204.5-0.8%209-2.5%2013.3l-7.4-1.4c-1.3%202.7-3%205.3-5%207.6l4.2%206.2c-3.3%203.3-7.1%205.8-11.1%207.6l-4.3-6.2c-2.8%201-5.8%201.7-8.9%201.8l-1.4%207.4c-4.5%200-9-0.8-13.3-2.5l1.4-7.4c-2.8-1.3-5.3-2.9-7.6-5l-6.2%204.3c-3.3-3.3-5.8-7.1-7.6-11.2l6.2-4.3c-1.1-2.8-1.7-5.8-1.8-8.9l-7.4-1.4c0-4.5%20.8-9%202.5-13.3l7.4%201.5c1.2-2.8%202.9-5.4%205-7.6l-4.3-6.3c3.3-3.3%207.1-5.8%2011.2-7.6l4.3%206.3c2.8-1.1%205.8-1.7%208.9-1.9l1.4-7.4Zm1.4%2018.9c-9.2-0.4-16.6%205.2-18.7%2014.2c-1.8%209.5%204.4%2018.7%2014%2020.5c9.5%201.8%2018.7-4.4%2020.5-14c1.8-9.5-4.5-18.7-14-20.5l-1.8-0.2Z%22%20fill%3D%22%23211c38%22%20transform%3D%22translate%28133.9%2C123%29%20rotate%28-45%29%20translate%28-133.9%2C-123%29%22%20style%3D%22animation%3A%204s%20linear%20infinite%20both%20a0_t%3B%22/%3E%3Cpath%20d%3D%22M164.7%2045.3l1.4%204.7c2-0.2%204%200%205.9%20.5l2.3-4.3c2.8%20.9%205.4%202.3%207.7%204.2l-2.3%204.3c1.5%201.3%202.8%202.8%203.8%204.5l4.6-1.4c1.4%202.7%202.3%205.5%202.6%208.4l-4.7%201.4c.1%202-0.1%204-0.6%205.9l4.3%202.3c-0.8%202.8-2.2%205.4-4.1%207.7l-4.3-2.3c-1.3%201.5-2.9%202.7-4.6%203.7l1.4%204.7c-2.6%201.4-5.5%202.3-8.3%202.6l-1.5-4.7c-1.9%20.1-3.9-0.1-5.8-0.6l-2.3%204.3c-2.8-0.9-5.4-2.2-7.8-4.1l2.3-4.3c-1.4-1.3-2.7-2.9-3.7-4.6l-4.7%201.4c-1.4-2.6-2.2-5.5-2.5-8.4l4.7-1.4c-0.1-1.9%20.1-3.9%20.6-5.8l-4.4-2.3c.9-2.8%202.3-5.5%204.2-7.8l4.3%202.3c1.3-1.4%202.8-2.7%204.5-3.7l-1.4-4.7c2.7-1.4%205.5-2.2%208.4-2.5Zm2.5%2012c-4.4%20.2-7.8%202.4-10%206c-3%205.6-0.9%2012.5%204.7%2015.5c5.5%202.9%2012.4%20.8%2015.4-4.7c2.9-5.5%20.9-12.5-4.7-15.4c-1.7-1-3.5-1.2-5.4-1.4Z%22%20fill%3D%22%23211c38%22%20transform%3D%22translate%28167.2%2C68.7%29%20rotate%2845%29%20translate%28-167.2%2C-68.7%29%22%20style%3D%22animation%3A%204s%20linear%20infinite%20both%20a1_t%3B%22/%3E%3Cpath%20d%3D%22M105.8%203c8.5%20.1%204.9-0.3%2010.9%20.6l-0.1%208.2c3.3%20.8%206.3%202.1%209.1%203.9l5.9-5.7c3.9%202.7%207.4%206.2%2010.2%2010.4l-5.8%205.7c1.7%202.9%202.9%206%203.6%209.2l8.2%20.1c.9%204.9%20.8%209.8-0.1%2014.6l-8.2-0.1c-0.8%203.2-2.1%206.3-3.9%209.1l5.7%205.8c-2.7%204-6.2%207.5-10.4%2010.3l-5.8-5.9c-2.8%201.7-5.9%203-9.1%203.7l-0.1%208.2c-4.9%20.9-9.9%20.8-14.7-0.2l.1-8.2c-3.2-0.8-6.2-2.1-9-3.8l-5.9%205.7c-4-2.8-7.4-6.3-10.2-10.5l5.8-5.7c-1.7-2.8-2.9-5.9-3.7-9.1l-8.2-0.1c-0.8-4.9-0.7-9.9%20.2-14.7l8.2%20.1c.8-3.2%202.1-6.2%203.9-9l-5.8-5.9c2.8-3.9%206.3-7.4%2010.5-10.2l5.7%205.8c2.9-1.7%206-2.9%209.2-3.6l.1-8.2l3.7-0.5Zm-0.1%2047.8l-9.3%209.2c3.5%202.5%207.8%203.9%2012.4%204c4.7%200%209.1-1.4%2012.7-3.9l-9.2-9.3c-1.1%20.4-2.2%20.6-3.4%20.6c-1.2%200-2.2-0.2-3.2-0.6Zm21.1-21l-9.3%209.2c.4%201%20.7%202.2%20.6%203.4c0%201.1-0.2%202.2-0.6%203.2l9.2%209.2c2.5-3.4%204-7.7%204-12.3c.1-4.7-1.4-9.1-3.9-12.7Zm-35.5-0.1c-2.5%203.5-4%207.7-4%2012.3c-0.1%204.8%201.4%209.1%203.9%2012.7l9.2-9.1c-0.4-1.1-0.6-2.2-0.6-3.4c0-1.2%20.3-2.3%20.7-3.3l-9.2-9.2Zm17.7%208.9c-2%200-3.6%201.6-3.7%203.6c0%202.1%201.6%203.7%203.6%203.7c2.1%200%203.7-1.6%203.7-3.6c.1-2-1.6-3.7-3.6-3.7Zm.2-18c-4.7-0.1-9.1%201.4-12.7%203.9l9.2%209.2c1.1-0.4%202.2-0.6%203.4-0.6c1.1%200%202.2%20.3%203.2%20.7l9.3-9.2c-3.5-2.5-7.8-4-12.4-4Z%22%20fill%3D%22%23211c38%22%20transform%3D%22translate%28109%2C42.3%29%20rotate%28-45%29%20translate%28-109%2C-42.3%29%22%20style%3D%22animation%3A%204s%20linear%20infinite%20both%20a2_t%3B%22/%3E%3C/g%3E%3C/svg%3E%0A"
        />
      </a>
      </div>
      <div footer class="card-footer p-2 card-text" *ngIf="program">
        <p class="h6">
        <a
        href="https://app.codecraftworks.com/programs/{{ program.id }}"
      >{{ program.name }}</a>
        </p>
        <p>
          <span *ngIf="program.level">Level {{ program.level }}</span>
          <span *ngIf="program.level && program.ageGroup">, </span>
          <span *ngIf="program.ageGroup">Ages {{ program.ageGroup }}</span>
          <span
            *ngIf="
              (program.ageGroup || program.level) &&
              program.timeAndDate &&
              program.timeAndDate.startDateTime
            "
            >,
          </span>
          <span *ngIf="program.timeAndDate && program.timeAndDate.startDateTime">
            Start Date {{ program.timeAndDate.startDateTime | date:'shortDate' }}
          </span>
        </p>
        <p *ngIf="program && program.stripe && program.stripe.price">
          {{ program.stripe.price / 100 | currency }}
          <span *ngIf="program.stripe.type === 'plan'">
            / {{ program.stripe.frequency }}
          </span>
        </p>
      </div>
    </div>
    <ng-template #loading>
      <codecraft-loading-spinner />
    </ng-template>
  `,
  styles: [`
    :host {
      display: block;
      max-width: 512px;
      min-width: 256px;
    }

    :host ::ng-deep a {
      text-decoration: none;
    }

    .card{
      background: linear-gradient(
        30deg,
        #d367c1 10%,
        #dedf40 25%,
        #62cb5c 50%,
        #00bbcb 75%,
        #ab79d6 90%
      );
    }

    .card-footer {
      background: white;
    }
  `],
  imports: [LoadingSpinnerComponent, NgIf, DatePipe, CurrencyPipe, NgOptimizedImage],
})
export class ProgramCardComponent implements OnInit {
  program;

  @Input()
  id: string;

  async ngOnInit() {
    if (this.id) {
      this.program = await this.getProgram(this.id);
    }
  }

  public getProgram(id: string): Promise<{ id: string; name: string; pictureUrl: string; timeAndDate: { startDateTime: Date; }; }> {
    return fetch(`https://firestore.googleapis.com/v1/projects/codecraft-platform/databases/(default)/documents/programs/${id}`)
      .then(response => response.json())
      .then(data => {
        const fields = data.fields;
        const program =  {
          id,
          name: fields.name.stringValue,
          pictureUrl: fields.pictureUrl.stringValue,
          timeAndDate: fields?.timeAndDate?.mapValue?.fields?.startDateTime?.timestampValue && { startDateTime : new Date(fields.timeAndDate.mapValue.fields.startDateTime.timestampValue) } || null,
          ageGroup: fields?.ageGroup?.stringValue || null,
          level: fields?.level?.integerValue || null,
          stripe: {
            price: fields?.stripe?.mapValue?.fields?.price?.integerValue || null,
            type: fields?.stripe?.mapValue?.fields?.type?.stringValue || null,
            frequency: fields?.stripe?.mapValue?.fields?.frequency?.stringValue || null,
          },
        }
        return program;
      })
      .catch(error => {
        console.error('Error fetching program:', error);
        return null;
      });
  }
}
